/* eslint-disable @typescript-eslint/no-unused-expressions */
import { CubeContext } from "@cubejs-client/react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { hasInvalidCubePayload } from "../../../../Utils/UtilFunctions/cubeUtil";
import fetchAndTrackCubeQuery from "../../../../Utils/UtilFunctions/trackedCubeQuery";
import ReportHeader from "../../components/ReportHeader";
import { InjectionData } from "../../data/InjectionAssets";
import AccordionKPIBlock from "../../HyPET/subpages/HyPETReportView/AccordionKPIBlock";
import axiosInstance from "../../utils/axiosInstance";
import { env } from "../../../../env";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import ContentSubHeader from "../../components/ContentSubHeader";
import { AppContext } from "../../../../App";
import buildBreadCrumbs from "../../utils/buildBreadCrumb";
import { Plant } from "../../../../models/Types_Interfaces";
import LoadingIndicator from "../../components/Loading";
import ErrorIndicator from "../../components/Error";
const baseURL = env?.microservice_assetsmgt;
type UpdateTroubleShootMode = "addTag" | "removeTag";
const ASSET_COLOR = "#ffc5d3";

function HyCAPTimeSeriesView() {
  const location = useLocation();
  const params = useParams();
  const { assetId, tag, parentId, hycapId, hycapChildId, hycapSubChildId, asset } = location.state;
  const { hycap, hycapchild, hycapsubchild } = params;

  const [kpiDataHyCAP, setKpiDataHyCAP] = useState([]);
  const [collapsed, setCollapsed] = useState<boolean[]>([]); // Track collapse state for each graph
  const [extended, setExtended] = useState<boolean[]>([]);
  const [refresh, setRefresh] = React.useState<any>(false);
  const range = [
    moment
      .tz("America/Los_Angeles")
      .subtract(12, "hours")
      .format("YYYY-MM-DDTHH:mm:ss.000"),
    moment.tz("America/Los_Angeles").format("YYYY-MM-DDTHH:mm:ss.000"),
  ];

  const [timeGranularity, setTimeGranularity] = useState<any>("minute");
  const [timeDimensions, setTimeDimensions] = useState<any>(range);
  const [measureType, setMeasureType] = useState<any>("FiveMinAgg");
  const topRef: any = useRef(null);
  const { cubejsApi } = React.useContext(CubeContext);
  const plantsList: Plant[] = useSelector(
    (state: any) => state.plantsList.plants
  );
  const { selectedPlantForCube, setSelectedPlantForCube }: any =
    useContext(AppContext);
  const plantCode = localStorage.getItem("InjectionPdmDefaultPlantCode");
  const validPlantCode = plantCode ? plantCode : selectedPlantForCube;
  setSelectedPlantForCube(validPlantCode);
  const dispatch = useDispatch();
  const seedsList = useSelector((state: any) => state.seedsList);

  const [currentAssetId, setCurrentAssetId] = useState<any>(null);
  const [excelData, setExcelData] = useState<any>([]);
  const [finalExcelData, setFinalExcelData] = useState<any>([]);
  const [fetchedAnnotations, setFetchedAnnotations] = React.useState<any>([]);
  const [expandedItems, setExpandedItems] = useState<any>({});
  const [collapsedItems, setCollapsedItems] = useState<any>({});
  const [compareAssets, setCompareAssets] = useState<any[]>([]);
  const levelsList = useSelector((state: any) => state.levelsList);
  const [updatedKpiList, setUpdatedKpiList] = useState<any[]>([]);
  const [queryKey, setQueryKey] = useState<string>(`hycap_single_assets_${assetId}_${moment().valueOf()}`);
  const [expandedMainAccordion, setExpandedMainAccordion] = useState<number | null>(null);
   const [isAssetHasSubCategoryValue, setIsAssetHasSubCategoryValue] = useState<boolean>(false);
    const [subCategoryData, setSubCategoryData] = useState<any[]>([]);

  const retrieveAssets = async () => {
    const response = await axiosInstance.get(`${baseURL}assets/${assetId}`);
    return response.data;
  };
  const {
    data: hycap_single_assets,
    error,
    isLoading,
  } = useQuery({
    queryKey: [queryKey],
    queryFn: retrieveAssets,
    refetchOnMount: false, // Prevents re-fetch on mount
    refetchOnWindowFocus: false, // Prevents re-fetch on window focus
  });

  const filteredHyCAPSingleAsset = hycap_single_assets?.data || null;

  const selectedPlant = useMemo(
    () =>
      plantsList.find(
        ({ plant_code }) => plant_code === selectedPlantForCube
      ) as Plant,
    [plantsList, selectedPlantForCube]
  );
  const localStorageCompareKey =
    selectedPlant.plant_code + "-injection-pdm-compare";
    const plantList = useSelector((state: any) => state.plantsList);
    const plantName =
    plantList.plants.find((item: any) => item.plant_code === selectedPlantForCube)
    ?.plant_name || "";

  useEffect(() => {
    if (
      filteredHyCAPSingleAsset &&
      filteredHyCAPSingleAsset.description === "Machines"
    ) {
      const kpiDataPoints: any =
        filteredHyCAPSingleAsset && filteredHyCAPSingleAsset.kpiDataPoints;
      setKpiDataHyCAP(kpiDataPoints);
      setExtended(Array(kpiDataPoints.length).fill(false));
      setCollapsed(Array(kpiDataPoints.length).fill(false));
      setIsAssetHasSubCategoryValue(false); 
    } else {
      if (
        filteredHyCAPSingleAsset &&
        filteredHyCAPSingleAsset.description !== "Mold"
      ) {
        const kpiDataPoints: any = filteredHyCAPSingleAsset.kpiDataPoints;
        setKpiDataHyCAP(kpiDataPoints);
        setExtended(Array(kpiDataPoints.length).fill(false));
        setCollapsed(Array(kpiDataPoints.length).fill(false));
        setIsAssetHasSubCategoryValue(false); 
      } else {
        const subCategory: any =
          (filteredHyCAPSingleAsset &&
            (filteredHyCAPSingleAsset as any).subCategory) ||
          [];
        const kpiDataWithSubcategories = subCategory.map((category: any) => ({
          subCategoryAsset: category.subCategoryAsset,
          kpiDataPoints: category.kpiDataPoints || [],
        }));
        setKpiDataHyCAP(kpiDataWithSubcategories);
        setSubCategoryData(kpiDataWithSubcategories);
        setExtended(Array(kpiDataWithSubcategories.length).fill(false));
        setCollapsed(Array(kpiDataWithSubcategories.length).fill(false));
        setIsAssetHasSubCategoryValue(true); 
      }
    }
  }, [filteredHyCAPSingleAsset, refresh]);

  const getParentAsset = (childAsset: any) =>
    childAsset?.parent_asset
      ? levelsList.levels.find((asset: any) => {
          return asset._id === childAsset.parent_asset;
        })
      : null;

  const updateTroubleShootData = (
    newTag: any,
    mode: UpdateTroubleShootMode,
    moldAssetName: string
  ) => {
    if (!filteredHyCAPSingleAsset) return;
    let subAsset3: any = {}
    let moldAsset: any = {};
    let subAssetTags: any = [];
    let moldSubCategory: any = []
    let moldAssetTags: any = [];
    let assetPreFix: string = tag?.slice(0,3)

    const parentAsset = {
      label: `${assetPreFix} HyCAPs`, // need to update pant number
      value: "",
      key: `${assetPreFix} HyCAPs`,
      id: parentId,
      color: ASSET_COLOR,
    };

    const subAsset = {
      label: `${assetPreFix} ${hycap}`, // need to update pant number
      value: tag,
      key: `${assetPreFix} ${hycap}`,
      id: hycapId,
      color: ASSET_COLOR,
      prefix: hycap,
    };

    const subAsset2: any = {
      label: `${hycap} ${hycapchild}`,
      value: `${hycap} ${hycapchild}`,
      key: `${hycap} ${hycapchild}`,
      parent: hycap,
      tag: tag,
      color: ASSET_COLOR,
      prefix: hycap,
      id: hycapChildId,
    };

    if (asset?.kpiDataPoints?.length) {
      asset?.kpiDataPoints?.forEach((tagObj: any) => {
        subAssetTags.push(tag + tagObj?.kpitag);
      });
    }

    if (
      hycapchild &&
      hycapchild !== "" &&
      asset?.asset_alias?.toLowerCase()?.includes("machines")
    ) {
      subAsset2["tagCollection"] = subAssetTags;
    }

    if(asset?.subCategory?.length) {
      moldSubCategory = asset?.subCategory
      asset?.subCategory?.forEach((item: any) => {
        item?.kpiDataPoints?.forEach((tagObj: any) => {
          if (typeof tagObj?.kpitag === "string") {
            moldAssetTags.push(tag + tagObj?.kpitag);
          } else {
            tagObj?.kpitag.forEach((subTag: any) => {
              moldAssetTags.push(tag + subTag);
            });
          }
        });
      });
    }

    if(hycapsubchild && hycapsubchild !== "") {
      subAsset3 = {
        label: `${hycap} ${hycapsubchild}`,
        value: `${hycap} ${hycapsubchild}`,
        key: `${hycap} ${hycapsubchild}`,
        parentTag: tag,
        color: ASSET_COLOR,
        prefix: hycap,
        parentKey: `${hycap} ${hycapchild}`,
        id: hycapSubChildId,
        tagCollection: subAssetTags,
        moldAssets: moldSubCategory
      };
    }

    if (moldAssetName !== "") {
      moldAsset = {
        label: `${hycap} ${moldAssetName}`,
        value: `${hycap} ${moldAssetName}`,
        key: `${hycap} ${moldAssetName}`,
        parentTag: tag,
        color: ASSET_COLOR,
        prefix: `${hycap}`,
        parentKey: `${hycap} ${hycapsubchild}`,
        id: "",
        tagCollection: moldAssetTags
      };
    }

    const existingCompareDataRaw = localStorage.getItem(localStorageCompareKey);

    const existingCompareData = existingCompareDataRaw
      ? JSON.parse(existingCompareDataRaw)
      : {};

    const updatedCompareData = {
      parentAssets: existingCompareData.parentAssets || [],
      plant_id: selectedPlant._id,
      subAssets: existingCompareData.subAssets || [],
      subAssets2: existingCompareData.subAssets2 || [],
      subAssets3: existingCompareData.subAssets3 || [],
      moldAssets: existingCompareData.moldAssets || [],
      tags: existingCompareData.tags || [],
    };

    // if (isMold && mode === "addTag") {
    //   // Adding moldAssets if it doesn't already exists in stored data
    //   if (
    //     !updatedCompareData.moldAssets.find(
    //       (asset: any) => asset.key === moldAssetKey
    //     )
    //   ) {
    //     updatedCompareData.moldAssets.push({
    //       color: ASSET_COLOR,
    //       key: moldAssetKey,
    //       label: moldAssetKey,
    //       value: moldAssetKey,
    //       tagCollection: moldAssetObj.kpiDataPoints.map(
    //         (kpiDataPoints: any) => subAsset3.parentTag + kpiDataPoints.kpitag
    //       ),
    //       prefix: hypet,
    //       parentKey: hypet + " Mold",
    //       parentTag: subAsset3.parentTag,
    //     });
    //   }
    // }

    // Adding parentAsset if it doesn't already exists in stored data
    if (
      !updatedCompareData.parentAssets.find(
        (asset: any) => asset.label === parentAsset.label
      )
    ) {
      updatedCompareData.parentAssets.push(parentAsset);
    }

    // Adding subAsset if it doesn't already exists in stored data
    if (
      !updatedCompareData.subAssets.find(
        (asset: any) => asset.label === subAsset.label
      )
    ) {
      updatedCompareData.subAssets.push(subAsset);
    }

    // Adding subAsset2 if it doesn't already exists in stored data
    if (
      !updatedCompareData.subAssets2.find(
        (asset: any) => asset.label === subAsset2.label
      )
    ) {
      updatedCompareData.subAssets2.push(subAsset2);
    }

    // Adding subAsset3 if it doesn't already exists in stored data
    if(Object.keys(subAsset3).length) {
      if (
        !updatedCompareData.subAssets3.find(
          (asset: any) => asset.label === subAsset3.label
        )
      ) {
        updatedCompareData.subAssets3.push(subAsset3);
      }
    }

    // Adding MoldAsset if it doesn't already exists in stored data
    if (Object.keys(moldAsset).length) {
      if (
        !updatedCompareData.moldAssets.find(
          (asset: any) => asset.label === moldAsset?.label
        )
      ) {
        updatedCompareData.moldAssets.push(moldAsset);
      }
    }
    if (mode === "addTag") {
      // Adding tag if it doesn't already exists in stored data
      if (
        !updatedCompareData.tags.find((tag: any) => tag.label === newTag.label)
      ) {
        updatedCompareData.tags.push(newTag);
      }
    } else {
      let tag = "";
      if (typeof newTag === "string") {
        tag = newTag;
      } else {
        tag = newTag?.tag + newTag?.kpi;
      }
      updatedCompareData.tags = updatedCompareData.tags.filter(
        ({ key }: any) => key !== tag
      );
    }

    localStorage.setItem(
      localStorageCompareKey,
      JSON.stringify(updatedCompareData)
    );

    setCompareAssets(updatedCompareData.tags);
  };

  const addCompareAsset = (tag: string, moldAsset?: string) => {
    const tagParts = tag.split("_");
    const kpiTag = tagParts.at(-2) + "_" + tagParts.at(-1);
    const kpiTagWithAsset = hycap.replace(" ", "_") + "_" + kpiTag;
    const kpiName = kpiTag;
    const moldAssetName = moldAsset?.length ? moldAsset : "";
    let titleArray =  ["HyCAP", hycap, hycapchild, hycapsubchild, kpiName]
    if(moldAssetName != "") {
      titleArray.splice(titleArray.length - 1, 0, moldAssetName)
    }

    updateTroubleShootData(
      {
        title: titleArray.join(" - "),
        color: ASSET_COLOR,
        key: tag,
        label: kpiTagWithAsset,
        value: kpiTagWithAsset,
      },
      "addTag",
      moldAssetName
    );
  };

  const removeCompareAsset = (tag: string, moldAsset?: string) => {
    const moldAssetName = moldAsset?.length ? moldAsset : "";
    updateTroubleShootData(tag, "removeTag", moldAssetName);
  }
  useEffect(() => {
    const existingCompareDataRaw = localStorage.getItem(
      "injection-pdm-compare"
    );
    const existingCompareData = existingCompareDataRaw
      ? JSON.parse(existingCompareDataRaw)
      : {};
    setCompareAssets(existingCompareData.tags || []);
  }, []);

  // const filteredHyCAPAssetPlant =
  // 	InjectionData &&
  // 	InjectionData.find(data => {
  // 		return data.plantName === 'RIA'
  // 	})

  // const filteredHyCAPAssetPlantHyCAP =
  // 	filteredHyCAPAssetPlant &&
  // 	(filteredHyCAPAssetPlant.injectionAssets.find(data => {
  // 		return data.mainAssets === 'HyCAP'
  // 	}) as { mainAsssets: string; subAssets: any[] } | undefined)

  // const filteredHyCAPAssetPlantHyCAPSubAsset =
  // 	filteredHyCAPAssetPlantHyCAP &&
  // 	(filteredHyCAPAssetPlantHyCAP.subAssets.find(data => {
  // 		return (data as any).machineName.toLowerCase() === hycap.toLowerCase()
  // 	}) as
  // 		| { machineName: string; subHyCAPAssets?: any[]; tag: string }
  // 		| undefined)

  // const hycapChild =
  // 	filteredHyCAPAssetPlantHyCAPSubAsset &&
  // 	(filteredHyCAPAssetPlantHyCAPSubAsset.subHyCAPAssets?.find(data => {
  // 		return (data as any).assetName.toLowerCase() === hycapchild?.toLowerCase()
  // 	}) as
  // 		| {
  // 				assetName: string
  // 				subAssets?: any[]
  // 				viewType: string
  // 				kpiDataPoints?: any[]
  // 		  }
  // 		| undefined)

  // const hycapSubChild =
  // 	hycapChild &&
  // 	(hycapChild.subAssets?.find(data => {
  // 		return (
  // 			(data as any).assetName.toLowerCase() === hycapsubchild?.toLowerCase()
  // 		)
  // 	}) as { assetName: string; kpiDataPoints?: any[] } | undefined)

  // useEffect(() => {
  // 	const finalData = [...finalExcelData]
  // 	finalData.push(excelData)
  // 	const cleanedData = finalData.filter(item => item && item?.length !== 0)
  // 	setFinalExcelData(cleanedData)
  // }, [excelData])

  // useEffect(() => {
  // 	if (hycapchild && hycapchild === 'Machines') {
  // 		const kpiDataPoints: any = hycapChild && hycapChild.kpiDataPoints
  // 		setKpiDataHyCAP(kpiDataPoints)
  // 		setExtended(Array(kpiDataPoints.length).fill(false))
  // 		setCollapsed(Array(kpiDataPoints.length).fill(false))
  // 	} else {
  // 		if (hycapSubChild && hycapSubChild.assetName !== 'Mold') {
  // 			const kpiDataPoints: any = hycapSubChild.kpiDataPoints
  // 			setKpiDataHyCAP(kpiDataPoints)
  // 			setExtended(Array(kpiDataPoints.length).fill(false))
  // 			setCollapsed(Array(kpiDataPoints.length).fill(false))
  // 		} else {
  // 			const subCategory: any =
  // 				(hycapSubChild && (hycapSubChild as any).subCategory) || []
  // 			const kpiDataWithSubcategories = subCategory.map((category: any) => ({
  // 				subCategoryAsset: category.subCategoryAsset,
  // 				kpiDataPoints: category.kpiDataPoints || []
  // 			}))
  // 			setKpiDataHyCAP(kpiDataWithSubcategories)
  // 			setExtended(Array(kpiDataWithSubcategories.length).fill(false))
  // 			setCollapsed(Array(kpiDataWithSubcategories.length).fill(false))
  // 		}
  // 	}
  // }, [hycapchild, hycapChild, hycapSubChild, refresh])

  // useEffect(() => {
  // 	const getSeedConfigValue = (seedsList: any, seedName: string) => {
  // 		const config = seedsList?.seeds?.find(
  // 			(seed: any) => seed?.seed_key_name === seedName
  // 		)?.seed_data_value
  // 		if (config) {
  // 			const filteredConfig = config.filter(
  // 				(item: any) => item?.key === 'HYPET'
  // 			)
  // 			if (filteredConfig.length > 0) {
  // 				return JSON.parse(filteredConfig[0]?.value)
  // 			} else {
  // 				return null
  // 			}
  // 		}
  // 		return null
  // 	}
  // 	const seedData: any = getSeedConfigValue(seedsList, 'IM_ASSETS')

  // 	// const kpiListMain: any = seedData.HyCAPSubAssets?.filter((data: any) => data.assetName === hycapchild).map((subData: any) => {
  // 	// 	const kpilistChild = subData.subAssets?.filter((item: any) => item.assetName === hycapsubchild);
  // 	// 	if (kpilistChild) return kpilistChild?.[0]?.kpiDataPoints
  // 	// })

  // 	// let machinesAssets: any = [];
  // }, [seedsList, refresh])

  // useEffect(() => {
  // 	window.scrollTo({ top: 0, behavior: 'smooth' })
  // 	if (topRef?.current) {
  // 		topRef.current.scrollIntoView({ block: 'start', inline: 'nearest' })
  // 		topRef.current.scrollTop = 0
  // 	}
  // 	dispatch({
  // 		type: 'LOAD_MESSAGES',
  // 		payload: {
  // 			assetId: filteredHyCAPSingleAsset?._id,
  // 			plantId: filteredHyCAPSingleAsset?.plant_id,
  // 			useCaseId: '668fe927d72b37f83d989032'
  // 		}
  // 	})
  // 	setCurrentAssetId(filteredHyCAPSingleAsset)
  // 	fetchAnnotations()
  // }, [])

  // const navigationItem = [
  // 	{
  // 		menuName: 'Home',
  // 		menuAction: '/usecase/injection-pdm'
  // 	},
  // 	{
  // 		menuName: 'HyCAP',
  // 		menuAction: '/usecase/injection-pdm/HyCAP'
  // 	}
  // ]
  // hycapChild
  // 	? navigationItem.push({
  // 			menuName: `${hycapchild}`,
  // 			menuAction: `/usecase/injection-pdm/HyCAP/${hycap}/${hycapchild}/asset-report/machine-view`
  // 		})
  // 	: null
  // hycapSubChild
  // 	? navigationItem.push({
  // 			menuName: `${hycapsubchild}`,
  // 			menuAction: `/usecase/injection-pdm/HyCAP/${hycap}/${hycapchild}/${hycapsubchild}/asset-report/timeseries-view`
  // 		})
  // 	: null

  // const toggleItemState = (key: string) => {
  // 	setExpandedItems((prev: any) => ({
  // 		...prev,
  // 		[key]: !prev[key]
  // 	}))
  // 	if (collapsedItems[key]) {
  // 		setCollapsedItems((prev: any) => ({
  // 			...prev,
  // 			[key]: !prev[key]
  // 		}))
  // 	}
  // }

  // const toggleCallapsedIcon = (key: string) => {
  // 	setCollapsedItems((prev: any) => ({
  // 		...prev,
  // 		[key]: !prev[key]
  // 	}))
  // }

  // const toggleCollapse = (index: number) => {
  // 	const newCollapsed = [...collapsed]
  // 	newCollapsed[index] = !newCollapsed[index] // Toggle collapse state for the specific graph
  // 	setCollapsed(newCollapsed)
  // }

  // const toggleExtend = (index: number) => {
  // 	const newExtended = [...extended]
  // 	newExtended[index] = !newExtended[index] // Toggle extended state for the specific graph

  // 	// If extending, ensure the graph is not collapsed
  // 	if (newExtended[index]) {
  // 		const newCollapsed = [...collapsed]
  // 		newCollapsed[index] = false
  // 		setCollapsed(newCollapsed)
  // 	}
  // 	setExtended(newExtended)
  // }

  // const fetchAnnotations = async () => {
  // 	if (timeGranularity) {
  // 		const annotationsQuery: any = {
  // 			dimensions: [
  // 				'Annotations.user_annotation',
  // 				'Annotations.datapoint',
  // 				'Annotations.timestamp',
  // 				'Annotations.created_datetime',
  // 				'Annotations.tagName',
  // 				'Annotations.deviceName'
  // 			],
  // 			order: {
  // 				'Annotations.timestamp': 'asc'
  // 			},
  // 			filters: [
  // 				// {
  // 				//   member: "Annotations.tagName",
  // 				//   operator: "contains",
  // 				//   values: neededTags,
  // 				// },
  // 				{
  // 					member: 'Annotations.granularity',
  // 					operator: 'equals',
  // 					values: [`${timeGranularity}`]
  // 				}
  // 			]
  // 		}

  // 		if (!hasInvalidCubePayload(annotationsQuery)) {
  // 			const {
  // 				isSuccess,
  // 				isError,
  // 				data: fetchedData
  // 			} = await fetchAndTrackCubeQuery(cubejsApi, annotationsQuery)
  // 			if (isSuccess) {
  // 				setFetchedAnnotations(fetchedData[0])
  // 			} else if (isError) {
  // 				dispatch({
  // 					type: 'LOAD_SNACKBAR',
  // 					payload: {
  // 						isShow: true,
  // 						message: 'Cube query has invalid payload',
  // 						type: 'error',
  // 						open: true
  // 					}
  // 				})
  // 			}
  // 		}
  // 	}
  // }

  // if (hycap_single_assets.kpiDataPoints?.length === 0 || hycap_single_assets.kpiDataPoints === undefined) {
  // 	return (
  // 		<Grid ref={topRef}>
  // 			<ReportHeader
  // 				pageHeader={
  // 					hycapSubChild
  // 						? `${hycapsubchild} - Report`
  // 						: `${hycapchild} - Report`
  // 				}
  // 				navigationItem={navigationItem}
  // 				setMeasureType={setMeasureType}
  // 				setTimeDimensions={setTimeDimensions}
  // 				setTimeGranularity={setTimeGranularity}
  // 				asset={currentAssetId}
  // 				timeGranularity={timeGranularity}
  // 				dateRange={timeDimensions}
  // 				measure={measureType}
  // 				setCurrentList={setKpiDataHyCAP}
  // 				compareAssets={compareAssets}
  // 				removeCompareAsset={removeCompareAsset}
  // 			/>
  // 			<Box>
  // 				SelectedAssets
  // 				{compareAssets.map(asset => asset._id)}
  // 			</Box>
  // 			<Box sx={{ mt: 2, mx: 2, my: 8 }} style={{ marginTop: '0px' }}>
  // 				<Grid container spacing={2} padding={1}>
  // 					<Grid item xs={12} sm={12} md={12} lg={12}>
  // 						<Grid container spacing={2}>
  // 							<Grid
  // 								item
  // 								xs={12}
  // 								sm={12}
  // 								md={12}
  // 								lg={12}
  // 								spacing={1}
  // 								padding={1}
  // 								style={{ background: '#293368', margin: '4px 4px 4px 12px' }}
  // 							>
  // 								NO KPI DATAPOINT
  // 							</Grid>
  // 						</Grid>
  // 					</Grid>
  // 				</Grid>
  // 			</Box>
  // 		</Grid>
  // 	)
  // } else {
  // 	return (
  // 		<Grid ref={topRef}>
  // 			<ReportHeader
  // 				pageHeader={
  // 					hycapSubChild
  // 						? `${hycapsubchild} - Report`
  // 						: `${hycapchild} - Report`
  // 				}
  // 				navigationItem={navigationItem}
  // 				setMeasureType={setMeasureType}
  // 				setTimeDimensions={setTimeDimensions}
  // 				setTimeGranularity={setTimeGranularity}
  // 				timeGranularity={timeGranularity}
  // 				asset={currentAssetId}
  // 				finalExcelData={finalExcelData}
  // 				setCurrentList={setKpiDataHyCAP}
  // 				setRefresh={setRefresh}
  // 				refresh={refresh}
  // 				compareAssets={compareAssets}
  // 				removeCompareAsset={removeCompareAsset}
  // 			/>
  // 			<Box sx={{ mt: 2, mx: 2, my: 8 }} style={{ marginTop: '0px' }}>
  // 				<Grid container>
  // 					<Grid item xs={12} sm={12} md={12} lg={12}>
  // 						<Grid container>
  // 							<Grid
  // 								item
  // 								xs={12}
  // 								sm={12}
  // 								md={12}
  // 								lg={12}
  // 							>
  // 								{kpiDataHyCAP?.map((item: any, index: number) =>
  // 									item.subCategoryAsset ? (
  // 										<Accordion style={{ marginBottom: '16px' }}>
  // 											<AccordionSummary
  // 												expandIcon={
  // 													<ExpandMoreIcon style={{ color: '#FFFFFF' }} />
  // 												}
  // 												aria-controls='panel1-content'
  // 												id='panel1-header'
  // 											>
  // 												<Typography variant='h4'>{item.subCategoryAsset}</Typography>
  // 											</AccordionSummary>
  // 											<AccordionDetails style={{ padding: '8px' ,backgroundColor: "#1f2655"}}>
  // 												{item.kpiDataPoints?.map(
  // 													(subItem: any, subIndex: number) => (
  // 														<Grid
  // 															item
  // 															xs={12}
  // 															sm={12}
  // 															md={12}
  // 															lg={12}
  // 															spacing={1}
  // 															padding={0}
  // 															key={subItem.kpiName}
  // 															style={{ flexGrow: 1, marginBottom: '10px' }}
  // 														>
  // 															<AccordionKPIBlock
  // 																title={`${subItem.kpiName}${subItem.kpiUnit ? ` (${subItem.kpiUnit})` : ''}`}
  // 																unit={subItem.kpiUnit}
  // 																onToggleExtend={() =>
  // 																	toggleItemState(`${index}-${subIndex}`)
  // 																}
  // 																onToggleCollapse={() =>
  // 																	toggleCallapsedIcon(`${index}-${subIndex}`)
  // 																}
  // 																isCollapsed={
  // 																	!!collapsedItems[`${index}-${subIndex}`]
  // 																}
  // 																isExtended={
  // 																	!!expandedItems[`${index}-${subIndex}`]
  // 																}
  // 																//tag={tagGeneration(filteredHyCAPSingleAsset?.devices[0].tag as any, subItem.kpitag as any)}
  // 																tag={
  // 																	Array.isArray(subItem.kpitag)
  // 																		? subItem.kpitag.map(
  // 																				(kpi: any) =>
  // 																					`${filteredHyCAPSingleAsset?.devices[0].tag}${kpi}`
  // 																			)
  // 																		: `${filteredHyCAPSingleAsset?.devices[0].tag}${subItem.kpitag}`
  // 																}
  // 																dateRange={timeDimensions}
  // 																granularity={timeGranularity}
  // 																measureType={measureType}
  // 																setExcelData={setExcelData}
  // 																fetchedAnnotations={fetchedAnnotations}
  // 																addCompareAsset={addCompareAsset}
  // 																removeCompareAsset={removeCompareAsset}
  // 																compareAssets={compareAssets}
  // 															/>
  // 														</Grid>
  // 													)
  // 												)}
  // 											</AccordionDetails>
  // 										</Accordion>
  // 									) : (
  // 										<Grid
  // 											item
  // 											xs={12}
  // 											sm={12}
  // 											md={12}
  // 											lg={12}
  // 											spacing={0}
  // 											padding={0}
  // 											style={{ flexGrow: 1 , marginBottom: '10px'}}
  // 										>
  // 											<AccordionKPIBlock
  // 												title={`${item.kpiName}${item.kpiUnit ? ` (${item.kpiUnit})` : ''}`}
  // 												data={item.data}
  // 												unit={item.kpiUnit}
  // 												isCollapsed={collapsed[index]}
  // 												isExtended={extended[index]}
  // 												onToggleCollapse={() => toggleCollapse(index)}
  // 												onToggleExtend={() => toggleExtend(index)}
  // 												tag={
  // 													Array.isArray(item.kpitag)
  // 														? item.kpitag.map(
  // 																(kpi: any) =>
  // 																	`${filteredHyCAPSingleAsset?.devices[0].tag}${kpi}`
  // 															)
  // 														: `${filteredHyCAPSingleAsset?.devices[0].tag}${item.kpitag}`
  // 												}
  // 												//tag={`${filteredHyCAPSingleAsset?.devices[0].tag}${item.kpitag}`}
  // 												dateRange={timeDimensions}
  // 												granularity={timeGranularity}
  // 												measureType={measureType}
  // 												setExcelData={setExcelData}
  // 												fetchedAnnotations={fetchedAnnotations}
  // 												addCompareAsset={addCompareAsset}
  // 												removeCompareAsset={removeCompareAsset}
  // 												compareAssets={compareAssets}
  // 											/>
  // 										</Grid>
  // 									)
  // 								)}
  // 							</Grid>
  // 						</Grid>
  // 					</Grid>
  // 				</Grid>
  // 			</Box>
  // 		</Grid>
  // 	)
  // }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (topRef?.current) {
      topRef.current.scrollIntoView({ block: "start", inline: "nearest" });
      topRef.current.scrollTop = 0;
    }
    if (filteredHyCAPSingleAsset){
      setCurrentAssetId(filteredHyCAPSingleAsset);
    }
    dispatch({
      type: "LOAD_MESSAGES",
      payload: {
        assetId: filteredHyCAPSingleAsset?._id,
        plantId: filteredHyCAPSingleAsset?.plant_id,
        useCaseId: "668fe927d72b37f83d989032",
      },
    });
    fetchAnnotations();
  }, [filteredHyCAPSingleAsset]);

  const toggleItemState = (key: string) => {
    setExpandedItems((prev: any) => ({
      ...prev,
      [key]: !prev[key],
    }));
    if (collapsedItems[key]) {
      setCollapsedItems((prev: any) => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  };

  const toggleCallapsedIcon = (key: string) => {
    setCollapsedItems((prev: any) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleCollapse = (index: number) => {
    const newCollapsed = [...collapsed];
    newCollapsed[index] = !newCollapsed[index]; // Toggle collapse state for the specific graph
    setCollapsed(newCollapsed);
  };

  const toggleExtend = (index: number) => {
    const newExtended = [...extended];
    newExtended[index] = !newExtended[index]; // Toggle extended state for the specific graph

    // If extending, ensure the graph is not collapsed
    if (newExtended[index]) {
      const newCollapsed = [...collapsed];
      newCollapsed[index] = false;
      setCollapsed(newCollapsed);
    }
    setExtended(newExtended);
  };

  const fetchAnnotations = async () => {
    if (timeGranularity) {
      const annotationsQuery: any = {
        dimensions: [
          "Annotations.user_annotation",
          "Annotations.datapoint",
          "Annotations.timestamp",
          "Annotations.created_datetime",
          "Annotations.tagName",
          "Annotations.deviceName",
        ],
        order: {
          "Annotations.timestamp": "asc",
        },
        filters: [
          // {
          //   member: "Annotations.tagName",
          //   operator: "contains",
          //   values: neededTags,
          // },
          {
            member: "Annotations.granularity",
            operator: "equals",
            values: [`${timeGranularity}`],
          },
        ],
      };

      if (!hasInvalidCubePayload(annotationsQuery)) {
        const {
          isSuccess,
          isError,
          data: fetchedData,
        } = await fetchAndTrackCubeQuery(cubejsApi, annotationsQuery);
        if (isSuccess) {
          setFetchedAnnotations(fetchedData[0]);
        } else if (isError) {
          dispatch({
            type: "LOAD_SNACKBAR",
            payload: {
              isShow: true,
              message: "Cube query has invalid payload",
              type: "error",
              open: true,
            },
          });
        }
      }
    }
  };

  if (isLoading) return <div><LoadingIndicator text="Loading Report....." /></div>;
  if (error) return <div><ErrorIndicator text={`Error Occured : ${error.message}`}/></div>;
  const appendPaths = {
    //4: hypetSubChildId ? "machineview" : '',
    3: hycapchild && hycapsubchild ? "machineview" : '',
    2: hycapchild ? 'machineview' : '',
  };
  const queryParams = {
    1: { aspid: parentId }, // 1st item query
  };

  const stateParams = {
    2: {
      assetId: hycapId,
      tag: tag,
      hycapId: hycapId,
      parentId: parentId,
      hycapChildId: hycapChildId,
    },
    3: {
      assetId: hycapChildId,
      tag: tag,
      hycapId: hycapId,
      parentId: parentId,
      hycapChildId: hycapChildId,
      hycapSubChildId: hycapSubChildId,
      asset: asset
    },
    4: {
      assetId: hycapSubChildId,
      tag: tag,
      hycapId: hycapId,
      parentId: parentId,
      hycapChildId: hycapChildId,
      hycapSubChildId: hycapSubChildId,
      asset: asset
    },
  };

  return (
    <Grid ref={topRef}>
      <ReportHeader
        pageHeader={`${filteredHyCAPSingleAsset.description} Report`}
        navigationItem={buildBreadCrumbs(plantName,
          ["HyCAPs",  hycap,
            ...(hycapchild ? [hycapchild] : []),
            ...(hycapsubchild ? [hycapsubchild] : [])],
            appendPaths,
            queryParams,
            stateParams
        )}
        setMeasureType={setMeasureType}
        setTimeDimensions={setTimeDimensions}
        setTimeGranularity={setTimeGranularity}
        timeGranularity={timeGranularity}
        asset={currentAssetId}
        finalExcelData={finalExcelData}
        setCurrentList={setKpiDataHyCAP}
        setRefresh={setRefresh}
        refresh={refresh}
        compareAssets={compareAssets}
        removeCompareAsset={removeCompareAsset}
        kpiDataPoints={hycap_single_assets?.data.kpiDataPoints}
        kpiChangeSummary={hycap_single_assets?.data.kpiChangeSummary}
        setUpdatedKpiList={setUpdatedKpiList}
        updatedKpiList={updatedKpiList}
        setQueryKey={setQueryKey}
        subCategoryData={subCategoryData}
        isAssetHasSubCategory={isAssetHasSubCategoryValue}
      />
      <ContentSubHeader>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {kpiDataHyCAP?.map((item: any, index: number) =>
                  item.subCategoryAsset ? (
                    <Accordion style={{ marginBottom: "16px" }} onChange={(_, isExpanded) =>
                      setExpandedMainAccordion(isExpanded ? index : null)
                    }>
                      <AccordionSummary
                       expandIcon={
                        expandedMainAccordion === index ? (
                          <ExpandLessIcon style={{ color: "#00FF00" }} /> // green icon when expanded
                        ) : (
                          <ExpandMoreIcon style={{ color: "#FFFFFF" }} /> // white when collapsed
                        )
                      }
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <Typography variant="h4">
                          {item.subCategoryAsset}
                        </Typography>
                      </AccordionSummary>
                      {expandedMainAccordion === index && (<AccordionDetails
                        style={{ padding: "8px", backgroundColor: "#1f2655" }}
                      >
                        {item.kpiDataPoints?.map(
                          (subItem: any, subIndex: number) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              spacing={1}
                              padding={0}
                              key={subItem.kpiName}
                              style={{ flexGrow: 1, marginBottom: "10px" }}
                            >
                              <AccordionKPIBlock
                                title={subItem.kpiName}
                                unit={subItem.kpiUnit}
                                onToggleExtend={() =>
                                  toggleItemState(`${index}-${subIndex}`)
                                }
                                onToggleCollapse={() =>
                                  toggleCallapsedIcon(`${index}-${subIndex}`)
                                }
                                isCollapsed={
                                  !!collapsedItems[`${index}-${subIndex}`]
                                }
                                isExtended={
                                  !!expandedItems[`${index}-${subIndex}`]
                                }
                                //tag={tagGeneration(filteredHyCAPSingleAsset?.devices[0].tag as any, subItem.kpitag as any)}
                                tag={
                                  Array.isArray(subItem.kpitag)
                                    ? subItem.kpitag.map(
                                        (kpi: any) => `${tag}${kpi}`
                                      )
                                    : `${tag}${subItem.kpitag}`
                                }
                                dateRange={timeDimensions}
                                granularity={timeGranularity}
                                measureType={measureType}
                                setExcelData={setExcelData}
                                fetchedAnnotations={fetchedAnnotations}
                                addCompareAsset={addCompareAsset}
                                removeCompareAsset={removeCompareAsset}
                                compareAssets={compareAssets}
                                isMoldAssetName={item.subCategoryAsset}
                                renderChart={expandedMainAccordion === index}
                              />
                            </Grid>
                          )
                        )}
                      </AccordionDetails>)}
                    </Accordion>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      spacing={0}
                      padding={0}
                      style={{ flexGrow: 1, marginBottom: "10px" }}
                    >
                      <AccordionKPIBlock
                        title={`${item.kpiName}`}
                        data={item.data}
                        unit={item.kpiUnit}
                        isCollapsed={collapsed[index]}
                        isExtended={extended[index]}
                        onToggleCollapse={() => toggleCollapse(index)}
                        onToggleExtend={() => toggleExtend(index)}
                        tag={
                          Array.isArray(item.kpitag)
                            ? item.kpitag.map((kpi: any) => `${tag}${kpi}`)
                            : `${tag}${item.kpitag}`
                        }
                        dateRange={timeDimensions}
                        granularity={timeGranularity}
                        measureType={measureType}
                        setExcelData={setExcelData}
                        fetchedAnnotations={fetchedAnnotations}
                        addCompareAsset={addCompareAsset}
                        removeCompareAsset={removeCompareAsset}
                        compareAssets={compareAssets}
                      />
                    </Grid>
                  )
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ContentSubHeader>
    </Grid>
  );
}

export default HyCAPTimeSeriesView;
